import { createTransaction } from "./createTransaction";
import { getTables } from "./getTables";
import { requestAuthorization } from "./requestAuthorization";

export const cltService = {
  requestAuthorization,
  getTables,
  createTransaction,
};
